import type { Params, TurnPolicy } from '../../lib/types';
import { Select, Slider, Toggle } from './widgets';

export function PotraceGroup({ params, setParam }: { params: Params; setParam: <K extends keyof Params>(k: K, v: Params[K]) => void }) {
  return (
    <>
      <Select<TurnPolicy>
        label="Turn policy"
        value={params.turnPolicy}
        options={[['black', 'black'], ['white', 'white'], ['left', 'left'], ['right', 'right'], ['minority', 'minority'], ['majority', 'majority']]}
        onChange={(v) => setParam('turnPolicy', v)}
      />
      <Slider label="Corner threshold (αmax)" min={0} max={1.34} step={0.01} value={params.smoothness} onChange={(v) => setParam('smoothness', v)} />
      <Toggle label="Optimize curves" value={params.opticurve} onChange={(v) => setParam('opticurve', v)} />
      <Slider label="Optimization tolerance" min={0} max={1.2} step={0.01} value={params.opttolerance} onChange={(v) => setParam('opttolerance', v)} />
    </>
  );
}
